import axios from "@/plugins/axios";

let url = "/api/v1/interview";

export const interview = {
    get(data) {
        return axios.get(`${url}/${data.code}`).then((result) => result.data);
    },
};

export default interview;
